export default (theme) => ({
    radioGroup: {
        paddingBottom: 0,
        marginBottom: -15,
    },
    loadingLoader: {
        padding: '40px 0',
        textAlign: 'center',
    },
});
